import React, { useEffect } from 'react'
import { matchPath, Route, Routes, useLocation } from 'react-router'
import { ABOUTUS, AITOOLBOOTCAMP1, AITOOLBOOTCAMP2, COMPANIES, CONTACT, COURSEDETAILS, COURSES, EVENTSDETAILS, HOME, OFFLINECOURSE, PLACEMENTS, PYTHON, PYTHON_DS_WITH_GENAI, QUIZEETHON, REFUND_POLICY, SUPERXALLBATCHE, SUPERXPROJECTDETAILS, SUPERXPROJECTS, SUPERXTESTIMONIALS, TANDC, TESTIMONIALS, s, UPCOMING_COURSE, FULLSTACK_COURSE } from '../_utils/Routes'
import { SUPERX } from '../_utils/Routes'
import { LOGIN_PERMISSION } from '../_utils/Routes'
import C2wLoginPermission from './c2wHomePage/setting/loginPermission/loginPermission'
// import C2wAboutus from './c2wHomePage/setting/aboutus/aboutus'
import C2wNavbar from '../components/C2wNavbar/navbarIndex'
import UpcomingCoursePage from './UpcomingCoursePage/UpcomingCoursePage'
import FullStackCoursePage from './FullStackCoursePage/FullStackCoursePage'
import C2wTermsAndConditions from './c2wHomePage/setting/termsandCondition/TermsAndConditions'
import C2wRefundPolicy from './c2wHomePage/setting/refund/RefundPolicy'
import { useSelector, useDispatch } from 'react-redux'
import { setCurrentUser } from '../C2wStore/actions'
import SettingsSheet from './c2wHomePage/setting/settingSheet/SettingsSheet'
import C2wCourses from './c2wHomePage/courses/courses'
import C2wPlacemets from './c2wHomePage/placements/placemets'
import C2wCompanies from './c2wHomePage/companies/companies'
import C2wCoursesDetails from './c2wHomePage/coursesDetails/coursesDetails'
import C2wLayout from '../components/C2wHome/Layout/C2wLayout'
import C2wEventsDetails from './c2wHomePage/events/eventDetails/EventsDetails'
import C2wAboutUs from './aboutus/AboutUs'
import C2wQuizeethon from './quizeethon/Quizeethon'
import C2wEnquiryForm from './c2wHomePage/setting/enuiryForm/enquiryForm'
import C2wPageNotFound from './pageNotFound/pageNotFound'
import C2wSuperxProjects from './C2wSuperxHomePage/superxProjects/superxProjects'
import C2wSuperxLayout from './C2wSuperxHomePage/superxLayout/superxLayout'
import C2wSuperxTestimonialsPage from './C2wSuperxHomePage/superxTestimonialsPage/superxTestimonialsPage'
// import C2wSuperxBatch from './C2wSuperxHomePage/superxBatches/superxBatch'
import C2wSuperxProjectDetail from './C2wSuperxHomePage/superxProjectDetails/superxProjectDetail'
// import C2wSuperxAllBatch from './C2wSuperxHomePage/superxBatches/superxBatch'
import C2wSuperxAllPrjLayout from './C2wSuperxHomePage/superxBatches/superxAllBatchPrjLayout'
import C2wOfflineCoursePage from './OfflineCoursePage/OfflineCoursePage'
import AiMasterclass from './AiMasterclass/AiMasterclass'
import SignupPage from './signup/SignupPage'
import LoginPage from './login/LoginPage'
import { SIGNUP, LOGIN } from '../_utils/Routes'
function RouterComponent() {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    const sessionUser = localStorage.getItem('sessionUser')
    if (sessionUser) {
      dispatch(setCurrentUser(JSON.parse(sessionUser)))
    }
  }, [dispatch])

  const settingFlag = useSelector((state) => state.data.settingFlag)
  const match =
    matchPath({ path: `${COURSEDETAILS}/:id`, end: true }, location.pathname) ||
    matchPath({ path: `${OFFLINECOURSE}/:id`, end: true }, location.pathname) ||
    matchPath({ path: FULLSTACK_COURSE, end: true }, location.pathname)
  const hideNavbar = Boolean(match);
  return (
    <div>
      
      {hideNavbar === false && location.pathname !== QUIZEETHON ? <C2wNavbar /> : null}
      {settingFlag && <SettingsSheet />}
      <Routes>
        <Route element={<C2wLayout />}>
          <Route path={HOME} element={<></>} />
          <Route element={<C2wSuperxLayout />}>
            <Route path={SUPERX} element={<></>} />
            <Route path={SUPERXPROJECTS} element={<C2wSuperxProjects />} />
            <Route path={SUPERXTESTIMONIALS} element={<C2wSuperxTestimonialsPage />} />
            <Route path={`${SUPERXALLBATCHE}/:slug`} element={<C2wSuperxAllPrjLayout />}></Route>
            <Route path={SUPERXPROJECTDETAILS} element={<C2wSuperxProjectDetail />} />
          </Route>
          <Route path={LOGIN_PERMISSION} element={<C2wLoginPermission />} />
          <Route path={ABOUTUS} element={<C2wAboutUs />} />
          <Route path={TANDC} element={<C2wTermsAndConditions />} />
          <Route path={REFUND_POLICY} element={<C2wRefundPolicy />} />
          <Route path={CONTACT} element={<C2wEnquiryForm />} />
          <Route path={COURSES} element={<C2wCourses />} />
          <Route path={`${COURSEDETAILS}/:slug`} element={<C2wCoursesDetails />} />
          <Route path={PLACEMENTS} element={<C2wPlacemets />} />
          <Route path={COMPANIES} element={<C2wCompanies />} />
          <Route path={`${EVENTSDETAILS}/:slug`} element={<C2wEventsDetails />} />
          <Route path={QUIZEETHON} element={<C2wQuizeethon />} />
          <Route path={`${UPCOMING_COURSE}/:slug`} element={<UpcomingCoursePage />} />
          <Route path={FULLSTACK_COURSE} element={<FullStackCoursePage />} />
          <Route path={`${OFFLINECOURSE}/:slug`} element={<C2wOfflineCoursePage />} />
          <Route path={`${AITOOLBOOTCAMP1}`} element={<AiMasterclass />} />
          <Route path={`${AITOOLBOOTCAMP2}`} element={<AiMasterclass />} />
          <Route path={SIGNUP} element={<SignupPage />} />
          <Route path={LOGIN} element={<LoginPage />} />
          <Route path='*' element={<C2wPageNotFound />} />
        </Route>
      </Routes>
    </div>
  )
}

export default RouterComponent
